import type { AxiosApiResponsePromise } from "~/api/apiResponseTypes.ts";
import axiosApi from "~/api/axiosApi";
import { usersDayStatesEndpoint } from "~/modules/timeTracking/api/timeTracking/timeTrackingApiEndpoints.ts";
import type {
	CreateTimeTrackingData,
	DayStates,
	GetUsersTimeTrackingsFilterType,
	TimeTracking,
	TimeTrackingExtendedType,
	UpdateTimeTrackingData,
} from "~/modules/timeTracking/api/timeTracking/timeTrackingTypes.ts";

export function getUsersTimeTrackings(
	userId: string,
	filter?: GetUsersTimeTrackingsFilterType,
): AxiosApiResponsePromise<TimeTrackingExtendedType[]> {
	return axiosApi.get(`users/${userId}/time-trackings`, { params: filter });
}

export function indexProjectsTimeTrackings(projectId: string): AxiosApiResponsePromise<TimeTracking[]> {
	return axiosApi.get(`projects/${projectId}/time-trackings`);
}

export function getUsersDayStatesByMonth({ userId, month }: {
	userId: string,
	month: string
}): AxiosApiResponsePromise<DayStates> {
	return axiosApi.get(usersDayStatesEndpoint(userId, month));
}

export const getTimeTracking = (userId: any, timeTrackingId: string): AxiosApiResponsePromise<TimeTracking> =>
	axiosApi.get(`users/${userId}/time-trackings/${timeTrackingId}`);

export function createTimeTracking(userId: string, data: CreateTimeTrackingData): AxiosApiResponsePromise<TimeTracking> {
	return axiosApi.post(`users/${userId}/time-trackings`, { ...data });
}

export function updateTimeTracking({ userId, timeTrackingId, data }: {
	userId: string,
	timeTrackingId: string,
	data: UpdateTimeTrackingData,
}): AxiosApiResponsePromise<TimeTracking> {
	return axiosApi.put(`users/${userId}/time-trackings/${timeTrackingId}`, { ...data });
}

export const deleteTimeTracking = ({ userId, timeTrackingId }: {
	userId: any,
	timeTrackingId: string
}): AxiosApiResponsePromise<void> =>
	axiosApi.delete(`users/${userId}/time-trackings/${timeTrackingId}`);
